<template>
  <div>
    <!--button @click="GetData">{{ $t('msg.ADMN030G010.035') }}</button>
    <button @click="SetData(data)">{{ $t('msg.ADMN030G010.036') }}</button-->
    <div :id="`deHolder_${Id}`"></div>
  </div>
</template>
<script>
import 'babel-polyfill'
import 'es6-promise/auto'
import { toServiceDomain } from '@/api/serviceDomain'

export default {
  name: 'DEXT5Editor',
  props: {
    Id: String,
    Runtimes: String,
    Width: String,
    Height: String,
    data: String
  },
  data: function () {
    return {
      editorData: ''
    }
  },
  watch: {

  },
  created () {
    console.log('dext editor data = ' + this.data)
  },
  destroyed () {
    this.restoreDextEditorIframeAlert()
  },

  mounted () {
    let handlerUrl = ''
    const commonUrl = toServiceDomain(process.env.VUE_APP_COMMON_URL)
    if (commonUrl.startsWith('http')) {
      handlerUrl = commonUrl
    } else if (commonUrl.startsWith('//')) {
      handlerUrl = location.protocol + commonUrl
    }
    handlerUrl += '/commons/dext5/editor/handler'

    let deOptions = {
        Id: this.Id,
        Width: this.Width || '100%',
        Height: this.Height || '500px',
        EditorHolder: 'deHolder_' + this.Id,
        HandlerUrl: handlerUrl,
        Runtimes: this.Runtimes || 'html5',
        Lang: this.$i18n.locale.toLowerCase(),
        Event: {
            LoadedEvent: this.onLoadedEvent
        }
    }

    if (typeof (DEXT5) === 'undefined') {
        this.$loadScript('/dext5editor/js/dext5editor.js')
            .then(() => {
                this.MakeEditor(deOptions)
            })
            .catch(() => {
                // Failed to fetch script
            })
    } else {
        this.MakeEditor(deOptions)
    }
  },
  methods: {
    suppressDextEditorIframeAlert () {
      const keywords = [
        '라이센스', 'License', 'Licensekey', '만료', 'Expired', 'Expire',
        '도메인', 'incorrect', 'contact us', 'product_key', 'license_key'
      ]

      const wrapIframe = (iframe) => {
        if (!iframe || iframe.__dextAlertWrapped) return
        iframe.__dextAlertWrapped = true

        const tryWrap = () => {
          try {
            const iw = iframe.contentWindow
            if (!iw || iw.__dextAlertPatched) return
            iw.__dextAlertPatched = true
            const orig = iw.alert
            iw.__dextOrigAlert = orig
            iw.alert = function (msg) {
              const text = String(msg || '')
              if (keywords.some(k => text.includes(k))) {
                console.warn('[DEXT5 iframe alert suppressed]', text)
                return
              }
              return orig.apply(iw, arguments)
            }
          } catch (e) { /* cross-origin이면 pass */ }
        }

        tryWrap() // 즉시 시도
        iframe.addEventListener('load', tryWrap) // 로드 후 재시도 (재사용 iframe 대응)
      }

      // 기존 iframe들
      document.querySelectorAll('iframe').forEach(wrapIframe)

      // 새로 생성되는 iframe 감지 (전역 1회 설치)
      if (!window.__dextIframeObserver) {
        const obs = new MutationObserver(muts => {
          muts.forEach(m => m.addedNodes.forEach(n => {
            if (n.nodeType !== 1) return
            if (n.tagName === 'IFRAME') wrapIframe(n)
            if (n.querySelectorAll) n.querySelectorAll('iframe').forEach(wrapIframe)
          }))
        })
        obs.observe(document.body, { childList: true, subtree: true })
        window.__dextIframeObserver = obs
      }
    },
    restoreDextEditorIframeAlert () {
      // MutationObserver 해제
      if (window.__dextIframeObserver) {
        window.__dextIframeObserver.disconnect()
        delete window.__dextIframeObserver
      }
      // 모든 iframe의 alert 원본 복구
      document.querySelectorAll('iframe').forEach(iframe => {
        try {
          const iw = iframe.contentWindow
          if (iw && iw.__dextOrigAlert) {
            iw.alert = iw.__dextOrigAlert
            delete iw.__dextOrigAlert
            delete iw.__dextAlertPatched
          }
        } catch (e) { /* cross-origin */ }
        delete iframe.__dextAlertWrapped
      })
    },
    MakeEditor: function (options) {
      this.suppressDextEditorIframeAlert()
      if (DEXT5.GetEditorByName(options.Id) !== null) {
          DEXT5.Destroy(options.Id)
      }

      DEXT5.config.Width = options.Width
      DEXT5.config.Height = options.Height
      DEXT5.config.Runtimes = options.Runtimes
      DEXT5.config.EditorHolder = options.EditorHolder
      DEXT5.config.Event = options.Event
      DEXT5.config.Lang = options.Lang
      if (options.HandlerUrl !== '') {
          DEXT5.config.HandlerUrl = options.HandlerUrl
      }

      new Dext5editor(options.Id)
    },
    GetData: function () {
      this.$emit('input', DEXT5.GetBodyValue(this.Id))
    },
    SetData: function (htmlString) {
        DEXT5.SetBodyValue(htmlString)
    },
    // DEXT5 Editor Event
    onLoadedEvent: function (editor) {
        console.log('onLoadedEvent ' + editor.ID)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
